/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { Box, Button, Grid, SxProps, TextField } from "@mui/material";
import { useStoreDispatch } from "../../../store/hooks";
import { setBasicDialogOpenFor } from "../../../store/helpers/helperReducers";
import BasicDialog from "../../../components/Shared/Dialogs/BasicDialog";
import { useSelector } from "react-redux";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import InputField from "../../../components/Shared/Inputs/InputField";
import NumberField from "../../../components/Shared/Inputs/NumberField";

interface IPayload {
  [key: string]: string;
}

interface IAddEditLanDeviceProps {
  modelOpenMode?: string;
  onBlurHandler?: (event: any) => void;
  errMsg?: IPayload;
  onSubmitData?: () => void;
  provisionVal?: number;
  setProvision?: (val: number) => void;
  isLoadingConfigStatus?: boolean;
}

const Provisioning: React.FC<IAddEditLanDeviceProps> = ({
  modelOpenMode = "Add",
  onBlurHandler,
  errMsg,
  onSubmitData,
  provisionVal,
  setProvision,
  isLoadingConfigStatus = false,
}) => {
  const dispatch = useStoreDispatch();
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);

  const handleChange = (event: any) => {
    event.preventDefault();
    const { name, value } = event.target;
    if (setProvision) {
      if (name === "provisionVal") {
        setProvision(value);
      }
    }
  };

  const handleSubmit = () => {
    if (onSubmitData && provisionVal) {
      onSubmitData();
    }
  };

  const dialogAction = (
    <Grid container justifyContent="space-around" alignItems="center" sx={{ pt: 2, pb: 2 }}>
      <Button onClick={() => dispatch(setBasicDialogOpenFor(undefined))}>Cancel</Button>
      {permissions?.hasOpCodeGroup("manage_topology") && (
        <Button disabled={isLoadingConfigStatus} variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      )}
    </Grid>
  );

  const formBoxSxProps: SxProps = { p: 2, "& .MuiTextField-root": { width: "100%", mb: 4 } };
  return (
    <BasicDialog headerTitle={`Provision Radio Node`} dialogActions={dialogAction}>
      <Box component="form" sx={formBoxSxProps} autoComplete="off">
        <Grid container sx={{ p: 4 }}>
          <Grid item md={12} sm={12} xs={12}>
            <NumberField
              label="Index"
              name="provisionVal"
              required={true}
              inputMode="number"
              value={provisionVal}
              onChange={handleChange}
              onBlur={onBlurHandler}
              error={!!errMsg?.provisionVal}
              helperText={errMsg?.provisionVal ?? ""}
            />
          </Grid>
        </Grid>
      </Box>
    </BasicDialog>
  );
};

export default Provisioning;
